import { useNavigate } from 'react-router-dom'

import { Card, CardContent } from '@/shared/components/ui/card'

export default function QuoteSummaryCards({ quotations = [], stats = null }) {
  const navigate = useNavigate()
  const totalCount = stats?.total ?? quotations.length
  const openCount = stats?.open ?? 0
  const inProgressCount = stats?.in_progress ?? 0
  const wonCount = stats?.won ?? stats?.closed ?? 0

  const statItems = [
    {
      title: 'TOTAL QUOTES',
      value: totalCount,
      subtitle: 'total quotations',
      onClick: () => navigate('/admin/quotes'),
    },
    {
      title: 'OPEN',
      value: openCount,
      subtitle: 'open leads',
      onClick: () => navigate('/admin/leads?status=open'),
    },
    {
      title: 'IN PROGRESS',
      value: inProgressCount,
      subtitle: 'in progress leads',
      onClick: () => navigate('/admin/leads?status=in_progress'),
    },
    {
      title: 'WON',
      value: wonCount,
      subtitle: 'won leads',
      onClick: () => navigate('/admin/leads?status=won'),
    },
  ]

  return (
    <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-4">
      {statItems.map((item) => (
        <Card
          key={item.title}
          onClick={item.onClick}
          className="min-h-[130px] cursor-pointer rounded-3xl border border-slate-200 shadow-sm transition-all hover:border-slate-400 hover:shadow-md active:scale-[0.98]"
        >
          <CardContent className="flex h-full flex-col justify-center p-5">
            <p className="text-sm font-semibold tracking-[0.18em] text-slate-500">
              {item.title}
            </p>

            <h2 className="mt-4 text-2xl font-bold leading-none text-slate-900">
              {item.value}
            </h2>

            <p className="mt-3 text-lg text-slate-500">{item.subtitle}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  )
}
